export function scrollToElementWithOffset(
  element: HTMLElement,
  offset: number
) {
  if (!element) return // Ensure the element exists
  const elementRect = element.getBoundingClientRect() // Get element position relative to viewport
  const scrollTop =
    document.documentElement.scrollTop || document.body.scrollTop // Modern alternative
  const targetScrollPosition = elementRect.top + scrollTop - offset // Calculate target position with offset

  // Scroll to the calculated position
  window.scrollTo({
    top: targetScrollPosition,
    behavior: 'smooth', // Optional: Adds smooth scrolling
  })
}
